module.exports = __webpack_public_path__ + "static/media/Кризкий_Александров_Владов (ММ).35a69a5b.pdf";